import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";
import { MoonStar, Sun } from "lucide-react";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  const label = theme === "dark" ? "Cambiar a modo claro" : "Activar modo oscuro";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={label}
          onClick={toggleTheme}
          className={cn(
            "relative h-10 w-10 border border-border bg-card text-primary shadow-none transition-all hover:border-primary/40 hover:bg-primary/5 hover:text-primary",
            "dark:bg-card/80 dark:text-slate-100"
          )}
        >
          <Sun
            className={cn(
              "absolute h-5 w-5 scale-100 rotate-0 transition-all duration-300",
              theme === "dark" && "-rotate-90 scale-0"
            )}
            aria-hidden="true"
          />
          <MoonStar
            className={cn(
              "absolute h-5 w-5 scale-0 rotate-90 transition-all duration-300",
              theme === "dark" && "scale-100 rotate-0"
            )}
            aria-hidden="true"
          />
          <span className="sr-only">{label}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="center" className="text-xs font-medium">
        {label}
      </TooltipContent>
    </Tooltip>
  );
};
